import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    getPatientList( seqUser, startDate, endDate ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/userMeasureRecord/getUserMeasureDataByRange';
            const conf = {
                headers: _HEADER()
            };
            const data = { seqUser, startDate, endDate };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },
    getDataForFilteredRomAndExerciseTimeByRange(data) {
        return new Promise(((resolve, reject) => {
            const url = _API + '/statistic/getDataForFilteredRomAndExerciseTimeByRange';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve( res );
                })
                .catch(err => {
                   reject(err);
                });
        }))

    }
}